import React from 'react';
import ServicePageShell from '../../components/ServicePageShell';
import PratiqueReligionStatic from './PratiqueReligionStatic';

export default function PratiqueReligion() {
  return (
    <ServicePageShell
      strapiApiId="annexe-religion"
      defaultSectionLabel="Annexes"
      defaultTitle="Pratique de la religion"
      StaticFallback={PratiqueReligionStatic}
    />
  );
}
